import {  HttpClient                              } from '@angular/common/http';
import {  EventEmitter, Injectable, Output        } from '@angular/core';
import {  Router                                  } from '@angular/router';
import {  MsalService                             } from '@azure/msal-angular';
import {  AuthenticationResult, EndSessionRequest } from '@azure/msal-browser';
import    jwt_decode                                from 'jwt-decode';
import {  map                                     } from 'rxjs/operators';
import {  environment                             } from '../../../../environments/environment';
import {  UnidadAdministrativaInterface           } from '../../../model/MesaAyudaInterfaces/unidadesAdmvaInterface';
import {  MesaAyudaCrudService                    } from '../mesa-ayuda-crud.service';
import {  UserService                             } from '../user.service';

const _scopes = environment.scopes;
const _me     = environment.meAzure;

@Injectable({ providedIn: 'root' })
export class MicrosoftAuthService
{
  @Output() msgError : EventEmitter<any> = new EventEmitter();
  
  constructor(
    private authService     : MsalService,
    private router          : Router,
    private http            : HttpClient,
    private _mesaAyudaCrud  : MesaAyudaCrudService,
    private userService     : UserService
  )
  {}

  public handleRedirectPromise()
  {
    console.debug('[AUTH] handleRedirectPromise() - iniciando manejo de redirect promise');
    this.authService.instance.handleRedirectPromise().then(res =>
      {
        console.debug('[AUTH] handleRedirectPromise() - respuesta:', res);
        if (res != null && res.account != null) {
          this.authService.instance.setActiveAccount(res.account);
          console.debug('[AUTH] handleRedirectPromise() - se estableció activeAccount:', res.account?.username ?? res.account?.homeAccountId);
        }
      }
    ).catch(err => console.error('[AUTH] handleRedirectPromise() - error:', err));
  }

  /**
   * Devuelve la promesa interna de MSAL handleRedirectPromise para que otros
   * componentes puedan esperar la resolución de una interacción pendiente.
   */
  public resolveRedirectPromise(): Promise<any> {
    try {
      return this.authService.instance.handleRedirectPromise();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public clearAuthState(clearAll: boolean = true): void
  {
    try {
      this.authService.instance.setActiveAccount(null);
    } catch (e) {
      // ignore
    }

    if (clearAll) {
      localStorage.clear();
      sessionStorage.clear();
      // limpiar userService
      this.userService.setUserInfo({
        city: null,
        department: null,
        email: null,
        empleado: null,
        nombre_usuario: null,
        officeLocation: null,
        organo: null,
        rol: null,
        roles: null
      });
      return;
    }

    this.clearMsalCache();
    this.clearAppUserInfo();
  }

  private clearMsalCache(): void
  {
    const storages = [localStorage, sessionStorage];

    storages.forEach(storage => {
      for (let i = storage.length - 1; i >= 0; i -= 1) {
        const key = storage.key(i);
        if (key && key.startsWith('msal')) {
          storage.removeItem(key);
        }
      }
    });
  }

  private clearAppUserInfo(): void
  {
    this.userService.setUserInfo({
      city: null,
      department: null,
      email: null,
      empleado: null,
      nombre_usuario: null,
      officeLocation: null,
      organo: null,
      rol: null,
      roles: null
    });
  }

  public login()
  {
    console.debug('[AUTH] login() - iniciando login popup');
    this.authService.loginPopup().subscribe(
      (response : AuthenticationResult) =>
      {
        console.debug('[AUTH] login() - respuesta AuthenticationResult:', response);
        this.authService.instance.setActiveAccount(response.account);
        console.debug('[AUTH] login() - activeAccount establecido:', response.account?.username ?? response.account?.homeAccountId);
        if (this.isLoggedIn())
          this.getUser();
      },
      error =>
      {
        console.error('[AUTH] login() - error popup:', error);
        this.msgError.emit({ mensaje: "Error de autenticación" });
      }
    );
  }

  public isLoggedIn()                           : boolean { return this.authService.instance.getActiveAccount() != null;                                            }
  private getToken()                            : any     { return this.authService.acquireTokenSilent({ scopes: [_scopes] }).pipe( map(res => res.accessToken ) )  }
  private getDecodedAccessToken(token: string)  : any     { try { return jwt_decode(token); } catch (Error) { return null; }                                        }

  public getUser(fromLogin: boolean = false)
  {
    console.debug('[AUTH] getUser() - llamada, fromLogin=', fromLogin, 'isLoggedIn=', this.isLoggedIn());
    if (this.isLoggedIn())
    {
      this.getToken().subscribe(
        async (token : any) =>
        {
          console.debug('[AUTH] getUser() - token obtenido (masked):', token ? (token.substring(0,10) + '...') : null);
          const tokenInfo = this.getDecodedAccessToken(token);
          // console.log(token)
          // console.log(tokenInfo)
          console.debug('[AUTH] getUser() - token decodificado:', tokenInfo);
          if( tokenInfo && tokenInfo.roles )
          {
            console.debug('[AUTH] getUser() - roles detectados:', tokenInfo.roles);
            await this.officeLocation();
            await this.city();
            await this.department();
            await this.employeeId();

            var Rol = "";
            tokenInfo.roles.forEach( (rol : any) =>
              {
                if( rol == "Usuarios.Admin" )       Rol = "A";
                if( rol == "Usuarios.Coordinador" ) Rol = "C";
                if( rol == "Usuarios.Soporte" )     Rol = "T";
                if( rol == "Usuarios.Empleado" )    Rol = "E";

                // Rol = "A";
                // Rol = "C";
                // Rol = "T";
                // Rol = "E";
              }
            );
            // localStorage.setItem( 'empleado'        , 'Número de Empleado'            );
            this.userService.setUserInfo({
              'nombre_usuario': tokenInfo.name,
              'rol': Rol,
              'email': tokenInfo.unique_name,
              'roles': tokenInfo.roles
            });
            console.debug('[AUTH] getUser() - userService actualizado:', this.userService.getUserInfo());
            
            if(fromLogin){
              if( Rol == "E" )  this.router.navigate([  '/solicitudes/listado/form-list-solicitud/solicitud'  ]);
              else              this.router.navigate([  '/'                                                   ]);
            }
          }
          else
          {
            console.warn('[AUTH] getUser() - token no contiene roles o es inválido:', tokenInfo);
            this.msgError.emit({ mensaje: "No cuentas con un rol de acceso" });
          }
        }
      );
    }
  }
  
  private officeLocation()
  {
    this.http.get(`${_me}/officeLocation`).subscribe(
      (officeLocation : any) =>
      {
        if(officeLocation != null)
        {
          console.debug('[AUTH] officeLocation() - valor:', officeLocation);
          this.userService.setUserInfo({'officeLocation': officeLocation['value']});
  
          this._mesaAyudaCrud.GetAreaAdmva( parseInt(officeLocation['value']) ).subscribe(
            (area : UnidadAdministrativaInterface) =>
            {
              if (area != null)
                this.userService.setUserInfo({'organo': area.nombre ?? ''});
              console.debug('[AUTH] officeLocation() - area administrativa:', area);
            }
          );
        }
      }
    );
  }
  private city()        { this.http.get(`${_me}/city`       ).subscribe((resp : any) => { console.debug('[AUTH] city() - valor:', resp); this.userService.setUserInfo({'city'        : resp['value']}) }); }
  private department()  { this.http.get(`${_me}/department` ).subscribe((resp : any) => { console.debug('[AUTH] department() - valor:', resp); this.userService.setUserInfo({'department'  : resp['value']}) }); }
  private employeeId()
  {
    this.http.get(`${_me}/employeeId` ).subscribe(
      (resp : any) =>
      {
        console.debug('[AUTH] employeeId() - valor:', resp);
        this.userService.setUserInfo(
          { 'empleado' : parseInt(resp['value']) }
          // { 'empleado' : 78562 } // PEPE
          // { 'empleado' : 58094 } // MARY
          // { 'empleado' : 58969 } // RAMIRO
          // { 'empleado' : 74667 } // CRISTINA
          // { 'empleado' : 63431 } // ARA
          // { 'empleado' : 664 } // ARQUI
        )
      }
    );
  }
  
  public logout(): void
  {
    // limpiar estado de la app y cache MSAL antes de solicitar logout
    this.clearAuthState(true);

    this.authService.logoutRedirect({
      postLogoutRedirectUri: '/', // o '/login', según lo que necesites
    } as EndSessionRequest);
  }
}
